import React, { useEffect, useState, Fragment } from 'react';
import { Card, Col, Container, Form, Row, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

// Menu Flotante
import { makeStyles } from '@material-ui/core/styles';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import { AiOutlineMenuUnfold } from "react-icons/ai";
import {MdPeopleAlt} from "react-icons/md";
import ModalAsignaApoderado from "./modal-asigna-apoderado";

import { Auth } from 'recupero-comunes';


const useStyles = makeStyles((theme) => ({
    root: {
        height: 380,
        transform: 'translateZ(0px)',
        flexGrow: 1,
    },
    speedDial: {
        position: 'absolute',
        top: '-350px',
        right: '-60px',
        zIndex: '150',
        /* marginTop: '-250px', */
        /* right: theme.spacing(5), */
    },
    menu: {
        width: '50px',
        height: '50px',
        zIndex: 250
    },
    tooltip: {
        fontSize: '12px',
        backgroundColor: 'black',
        color: 'white'
    }
}));
const useStylesToltip = makeStyles((theme) => ({
  tooltip: {
      fontSize: '12px',
      backgroundColor: 'black',
      color: 'white'
  }
}));


const MenuFlotanteDetalleCaso = ({ antecedentesCaso, setReloadCaso }) => {
    const dispatch = useDispatch();


    // Menu FLotante
    const classes = useStyles();
    const classesTooltip = useStylesToltip();
    const [open, setOpen] = React.useState(false);
    const [hidden, setHidden] = React.useState(false);
    const handleOpen = () => { setOpen(true); };
    const handleClose = () => { setOpen(false); };

    const [showAsignarApoderado, setShowAsignarApoderado] = useState(false);

    const actions = [
        { icon: <MdPeopleAlt size={35} style={{ color: '#00aeab' }} />, name: 'Asignar Apoderado', id: '1' }
    ];

    const handleAction = async (action) => {
        if (action === "1") handleShowAsignarApoderado(true);  // Asignar Apoderado
    }
    const handleShowAsignarApoderado = (value) => {
        setShowAsignarApoderado(value);
    }
    const handleCloseAsignarApoderado = () => {
        setShowAsignarApoderado(false);
    }
    return (
        <Fragment>
            <Container className='mb-4 mt-2 position-relative'>
                <SpeedDial
                    ariaLabel="SpeedDial tooltip example"
                    className={classes.speedDial}
                    hidden={hidden}
                    icon={<AiOutlineMenuUnfold size={30} />}
                    onClose={handleClose}
                    onOpen={handleOpen}
                    open={true}
                >
                    {actions.map((action) => (
                        <SpeedDialAction
                            key={action.id}
                            icon={action.icon}
                            tooltipTitle={action.name}
                            className={classes.menu}
                            onClick={() => handleAction(action.id)}
                            TooltipClasses={classesTooltip}
                        />
                    ))}
                </SpeedDial>
                { antecedentesCaso && Object.keys(antecedentesCaso).length > 0 &&   
                    <ModalAsignaApoderado
                        showAsignarApoderado={showAsignarApoderado}
                        handleCloseAsignarApoderado={handleCloseAsignarApoderado}
                        antecedentesCaso={antecedentesCaso}
                        setReloadCaso={setReloadCaso}
                    />
                }
            </Container>            
        </Fragment>
    )
}

export default MenuFlotanteDetalleCaso